import { Component } from '@angular/core'
import { RequiredAsteriskComponent } from '../required-asterisk/required-asterisk.component'

@Component({
  selector: 'app-required-fields',
  templateUrl: './required-fields.component.html',
  styleUrls: ['./required-fields.component.scss'],
  imports: [RequiredAsteriskComponent],
})
export class RequiredFieldsComponent {}
